import { screen } from 'components/styles/variables';

interface SpacerProps {
  size: string;
  smSize?: string;
  mdSize?: string;
  lgSize?: string;
}

export default function Spacer({
  size,
  smSize = size,
  mdSize = smSize || size,
  lgSize = mdSize || smSize || size,
}: SpacerProps): JSX.Element {
  return (
    <div className="spacer">
      <style jsx>{`
        .spacer {
          flex-basis: ${size};
          flex-shrink: 0;
        }

        @media (min-width: ${screen.smMin}) {
          .spacer {
            flex-basis: ${smSize};
          }
        }

        @media (min-width: ${screen.mdMin}) {
          .spacer {
            flex-basis: ${mdSize};
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .spacer {
            flex-basis: ${lgSize};
          }
        }
      `}</style>
    </div>
  );
}
